import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthorizationService } from '../../services';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {
    authInterval: any;
    username: string = '';

    constructor(private activatedRoute: ActivatedRoute, private authorizationService: AuthorizationService, private router: Router) {
        this.authorizationService.nameChangeMessage.subscribe(username => this.username = username);
    }

    ngOnInit() {
        //  check if auth+auth is empty or not by using the auth service's authenticated method
        this.authInterval = setInterval(() => {
            this.verifyAuthentication();
        }, 500);
    }

    verifyAuthentication(): void {
        var isAuthenticated = this.authorizationService.authenticated();
        if (isAuthenticated) {
            this.authorizationService.getClaims().then((claims) => {
                if (claims || JSON.stringify(claims) !== '{}') {
                    this.authorizationService.restoreIdentityClaims();
                }
            });
        } else {
            //  go get a new token
            this.authorizationService.initAuth().then((returnedPromise) => {
                this.authorizationService.restoreIdentityClaims();
            });
        }
        this.router.navigate(['/search-bond'], { relativeTo: this.activatedRoute });
        clearInterval(this.authInterval);
    }
}

